import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { initSentry } from './utils/initSentry';
import { App } from './App';

initSentry(import.meta.env.VITE_SENTRY_DNS, import.meta.env.VITE_APP_ENV);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
